import { createContext, useContext } from "react";
import type { OperatingSystemPreviewDescriptor } from "@/lib/operating-systems";

export const OPERATING_SYSTEM_PREVIEW_PROVIDER_LOADING_EVENT = "applyt:os-preview-provider-loading";
export const OPERATING_SYSTEM_PREVIEW_LOADED_EVENT = "applyt:os-preview-loaded";

export type OperatingSystemPreviewProviderLoadingDetail = {
  cacheKey: string;
  osId: string;
};

export type OperatingSystemPreviewLoadedDetail = {
  cacheKey: string;
  osId: string;
};

export type OperatingSystemPreviewReloadOptions = {
  force?: boolean;
};

export type OperatingSystemPreviewCacheValue = {
  activatePreview: (descriptor: OperatingSystemPreviewDescriptor, target: HTMLElement) => () => void;
  prewarmPreview: (descriptor: OperatingSystemPreviewDescriptor | null) => void;
  keepPreviewAlive: (descriptor: OperatingSystemPreviewDescriptor | null) => void;
  reloadPreview: (descriptor: OperatingSystemPreviewDescriptor | null, options?: OperatingSystemPreviewReloadOptions) => void;
  isPreviewCached: (descriptor: OperatingSystemPreviewDescriptor | null) => boolean;
  isPreviewLoaded: (descriptor: OperatingSystemPreviewDescriptor | null) => boolean;
  isPreviewFrameVisible: (descriptor: OperatingSystemPreviewDescriptor | null) => boolean;
  isPreviewLoadedNow: (descriptor: OperatingSystemPreviewDescriptor | null) => boolean;
  isPreviewProviderLoading: (descriptor: OperatingSystemPreviewDescriptor | null) => boolean;
  isPreviewUnavailable: (descriptor: OperatingSystemPreviewDescriptor | null) => boolean;
  getPreviewSnapshot: (descriptor: OperatingSystemPreviewDescriptor | null) => string | null;
};

export const OperatingSystemPreviewCacheContext = createContext<OperatingSystemPreviewCacheValue | null>(null);

export function useOperatingSystemPreviewCache() {
  const context = useContext(OperatingSystemPreviewCacheContext);
  if (!context) {
    throw new Error("useOperatingSystemPreviewCache must be used inside OperatingSystemPreviewCacheProvider");
  }
  return context;
}
